export default __webpack_public_path__ + "static/media/moekah-logos-gruppe.1d50b29e.png";